document.addEventListener('DOMContentLoaded', function () {
  var reviewSwiper = document.querySelector('.reviews-block.swiper');

  if (reviewSwiper && typeof Swiper !== 'undefined') {
    new Swiper(reviewSwiper, {
      loop: false,
      slidesPerView: 1,
      slidesPerView: 1,   // 👈 shows left & right slides
      spaceBetween: 20,
      pagination: {
        el: reviewSwiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }


  var stickyButton = document.querySelector(".product__sticky-cart button");

  if (stickyButton) {
    stickyButton.addEventListener("click", function (e) {
      e.preventDefault();
      const submitBtn = document.querySelector(".product__info-container .product-form__submit");
      submitBtn.click();
    });
  }

  const stickyButtonWrapper = document.querySelector(".product__sticky-cart");
const submitBtn = document.querySelector(".product__info-container .product-form__submit");

if (stickyButtonWrapper && submitBtn) {
  // hide sticky button by default
  stickyButtonWrapper.classList.add("hidden");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // submit button is visible → hide sticky
          stickyButtonWrapper.classList.add("hidden");
        } else {
          // submit button is NOT visible → show sticky
          stickyButtonWrapper.classList.remove("hidden");
        }
      });
    },
    {
      threshold: 0.1 // triggers when at least 10% visible
    }
  );

  observer.observe(submitBtn);
}


});